import {isInStock} from '@/components/containers/pdp/utils/retailer-helpers';

const ProductType = Object.freeze({
  AFTERMARKET: 'am',
  BIKE: 'bike',
});

export function determineOptionAvailability({option, product, selectedAttributes, b2b, isECommAvailable}) {
  const variantAttributeCodes = product?.variantAttributesDirectory?.map((attr) => attr.code) || [];
  // Filter selectedAttributes to only include keys present in variantAttributeCodes
  const filteredSelectedAttributes = Object.fromEntries(
    Object.entries(selectedAttributes).filter(([key]) => variantAttributeCodes.includes(key))
  );
  const variant = product.variants.find((v) => {
    return Object.entries(filteredSelectedAttributes).every(([key, value]) => {
      if (key === option.code) {
        return v.variantAttributes[option.code] === option.value;
      }
      return v.variantAttributes[key] === value;
    });
  });

  const hasStock = variant?.isLocallyStockAvailable || isInStock(false, variant?.globalStockStatus);
  return b2b || (isECommAvailable && hasStock);
}

export function getSelectedVariant({product, selectedAttributes}) {
  const variant = product.variants.find((v) => {
    return Object.entries(v.variantAttributes).every(([key, value]) => {
      return selectedAttributes[key] === value;
    });
  });
  return variant || null;
}

//eslint-disable-next-line no-unused-vars
const Variant = (variantCode, product, b2b = false) => {
  const variant = product?.variants?.find((variant) => variant.code === variantCode);
  const get = () => {
    return variant;
  };
  const isAftermarket = () => {
    return variant?.productType === ProductType.AFTERMARKET;
  };
  return {get, isAftermarket};
};

export default Variant;
